// Shared site constants: contact info, images, dishes
export const CONTACT = {
  name: "Le Goût du Fouta",
  phoneDisplay: "06 63 98 04 74",
  phoneTel: "+33663980474",
  whatsapp: "33663980474",
  address: "118 Rue Championnet",
  city: "75018 Paris, France",
  metro: "Ligne 4 · Porte de Clignancourt",
  tiktok: "https://tiktok.com/@nene.gb1204?_r=1&_t=ZG-998VkqPcDCb",
  tiktokHandle: "@nene.gb1204",
  mapsQuery: "118+Rue+Championnet+75018+Paris+France",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=118+Rue+Championnet+75018+Paris",
  uberEats: "https://www.ubereats.com/fr/store/le-gout-du-fouta/JylqX-KERxSe8XXb_gUSwA",
  theFork: "https://www.thefork.fr/restaurant/le-gout-du-fouta-r861986",
  rating: "4,7",
  reviewsCount: 22,
};

const TF = "/img";
export const REAL = {
  interior: `${TF}/interior.jpg`,
  tieb: `${TF}/tieb.jpg`,
  attieke: `${TF}/attieke.jpg`,
  yassa: `${TF}/yassa_poulet.jpg`,
  maffe: `${TF}/maffe.jpg`,
  poulet: `${TF}/poulet.jpg`,
  brownGrill: `${TF}/browngrill.jpg`,
  beignets: `${TF}/beignets.jpg`,
  brochette: `${TF}/brochette.jpg`,
  poisson: `${TF}/poisson.jpg`,
  bourakhe: `${TF}/bourakhe.jpg`,
  toGombo: `${TF}/to_gombo.jpg`,
  choukouya: `${TF}/choukouya.jpg`,
  poissonBraise: `${TF}/poisson_braise.jpg`,
  thiepBlanc: `${TF}/thiep_blanc.jpg`,
  mafeHako: `${TF}/mafe_hako.jpg`,
  pastel: `${TF}/pastel.jpg`,
  mafePoutai: `${TF}/mafe_poutai.jpg`,
  kandia: `${TF}/kandia.jpg`,
  lafidiFonio: `${TF}/lafidi_fonio.jpg`,
  lafidiMaaro: `${TF}/lafidi_maaro.jpg`,
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/18698241/pexels-photo-18698241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1920",
  spread: "https://images.pexels.com/photos/18698241/pexels-photo-18698241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1500",
  tieb: "https://images.pexels.com/photos/18805640/pexels-photo-18805640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1200",
  yassa: "https://images.pexels.com/photos/37667720/pexels-photo-37667720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1200",
  maffe: "https://images.pexels.com/photos/15131170/pexels-photo-15131170.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1200",
  attieke: "https://images.pexels.com/photos/26587856/pexels-photo-26587856.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1200",
  brochette: "https://images.unsplash.com/photo-1603360946369-dc9bb6258143?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PRICE = "12€";

export const DISHES = [
  {
    id: "tieb",
    name: "Le Riz Jollof (Thiep / Ceebu Jën)",
    img: REAL.tieb,
    price: "14€",
    fr: "Véritable emblème de la cuisine ouest-africaine, ce riz mijoté dans une sauce généreuse de tomates, d'oignons et d'épices est le frère de cœur du riz au gras. Star incontestée des tables sénégalaises, guinéennes, nigérianes et ghanéennes, il incarne le partage et la convivialité à chaque bouchée.",
    en: "A true emblem of West African cuisine, this rice simmered in a generous sauce of tomatoes, onions and spices is the soul-sibling of ceebu jën. The undisputed star of Senegalese, Guinean, Nigerian and Ghanaian tables — sharing and conviviality in every bite.",
    tag: "Signature",
  },
  {
    id: "yassa",
    name: "Poulet Yassa",
    img: REAL.yassa,
    price: "14€",
    fr: "Un plat emblématique de la cuisine sénégalaise : morceaux de poulet mariné puis mijoté dans une sauce à base d'oignons caramélisés, de citron et de moutarde, relevée d'épices parfumées. Servi avec du riz blanc, ce plat offre un équilibre savoureux entre acidité, douceur et caractère.",
    en: "A signature dish of Senegalese cuisine: marinated chicken pieces slow-cooked in a sauce of caramelised onions, lemon and mustard, lifted with fragrant spices. Served with white rice, it offers a tasty balance of tang, sweetness and character.",
    tag: "Populaire",
  },
  {
    id: "maffe",
    name: "Maffé",
    img: REAL.maffe,
    price: "15€",
    fr: "Ragoût généreux à la pâte d'arachide, viande tendre et épices douces.",
    en: "A generous groundnut stew with tender meat and warm, mellow spices.",
    tag: "Réconfort",
  },
  {
    id: "attieke",
    name: "Attiéké",
    img: REAL.attieke,
    price: "16€",
    fr: "Semoule de manioc ivoirienne servie avec poisson grillé et sauce fraîche.",
    en: "Ivorian cassava semolina served with grilled fish and a bright fresh salsa.",
    tag: "Côte d'Ivoire",
  },
  {
    id: "brochette",
    name: "Brochette",
    img: REAL.brochette,
    price: "15€",
    fr: "Brochettes grillées au feu de braise, épices maison et oignons rouges.",
    en: "Char-grilled skewers over live coals, house spice rub and red onions.",
    tag: "Grillé",
  },
  {
    id: "bourakhe",
    name: "Bourakhé",
    img: REAL.bourakhe,
    fr: "La « sauce feuille » guinéenne : feuilles de manioc ou de patate douce mijotées à l'arachide, avec viande et poisson.",
    en: "The Guinean 'leaf sauce': cassava or sweet-potato leaves slow-cooked with groundnut, meat and fish.",
    tag: "Guinée",
  },
  {
    id: "to-gombo",
    name: "Tô & Sauce Gombo",
    img: REAL.toGombo,
    fr: "Tô de manioc accompagné d'une généreuse sauce au gombo, préparée selon la tradition. Une pâte de manioc douce et fondante, servie avec une sauce gombo onctueuse, savoureuse et délicatement relevée.",
    en: "Cassava tô served with a generous, traditionally-made okra sauce. A soft, melting cassava paste paired with a smooth, savoury and delicately spiced gombo sauce.",
    tag: "Tradition",
  },
  {
    id: "choukouya",
    name: "Choukouya / Dibi",
    img: REAL.choukouya,
    price: "16€",
    fr: "Viande de veau grillée à la braise et aux oignons. Accompagnée, au choix : aloko, frites ou salade.",
    en: "Char-grilled veal with onions. Served with your choice of aloko (fried plantains), fries or salad.",
    tag: "Grillade",
  },
  {
    id: "poisson-braise",
    name: "Poisson braisé",
    img: REAL.poissonBraise,
    price: "14€",
    fr: "Poisson entier braisé, servi avec de l'aloko et sa petite salade fraîche au citron.",
    en: "Whole braised fish, served with aloko (fried plantains) and a fresh little lemon salad.",
    tag: "Braisé",
  },
  {
    id: "thiep-blanc",
    name: "Thiep blanc au poisson",
    img: REAL.thiepBlanc,
    price: "14€",
    fr: "Riz blanc parfumé, poisson et légumes mijotés (chou, carotte, aubergine, feuilles). Un classique tout en douceur.",
    en: "Fragrant white rice with braised fish and slow-cooked vegetables (cabbage, carrot, aubergine, greens). A gentle classic.",
    tag: "Sénégal",
  },
  {
    id: "mafe-hako",
    name: "Sauce Feuilles de Manioc (Maffé Haako Bantara)",
    img: REAL.mafeHako,
    price: "15€",
    fr: "Un grand classique de la cuisine ouest-africaine, mijoté avec de tendres feuilles de manioc pilées, enrichi d'une sauce arachide onctueuse et parfumé aux épices traditionnelles. Servi généreusement avec du riz blanc, ce plat réconfortant marie douceur et caractère pour une expérience authentique.",
    en: "A great West African classic, slow-cooked with tender pounded cassava leaves, enriched with a smooth groundnut sauce and fragrant traditional spices. Generously served with white rice, this comforting dish blends softness and character for a truly authentic experience.",
    tag: "Réconfort",
  },
  {
    id: "pastel",
    name: "Pastel au Thon",
    img: REAL.pastel,
    price: "5€",
    fr: "Une galette croustillante généreusement garnie de thon émietté et relevé aux épices, frite jusqu'à obtenir un extérieur doré et croquant. Idéale en apéritif ou en encas gourmand.",
    en: "A crispy pastry generously filled with flaked, spiced tuna, fried to a golden, crunchy finish. Perfect as an aperitif or a gourmet snack.",
    tag: "Entrée",
  },
  {
    id: "mafe-poutai",
    name: "Sauce Feuilles de Patates Douces (Maffé Haako Poutai)",
    img: REAL.mafePoutai,
    price: "15€",
    fr: "Un plat traditionnel préparé à partir de tendres feuilles de patates douces mijotées dans une sauce arachide onctueuse, relevée d'épices soigneusement dosées. Servie avec du riz blanc, cette sauce généreuse offre un équilibre parfait entre douceur et caractère.",
    en: "A traditional dish made from tender sweet-potato leaves simmered in a smooth groundnut sauce, seasoned with carefully balanced spices. Served with white rice, this generous sauce offers a perfect balance of softness and character.",
    tag: "Réconfort",
  },
  {
    id: "kandia",
    name: "Soupe Kandia (Sauce Gombo)",
    img: REAL.kandia,
    price: "15€",
    fr: "Une spécialité incontournable de la cuisine ouest-africaine : gombos mijotés longuement pour obtenir une sauce onctueuse et parfumée, souvent enrichie de viande ou de poisson et relevée d'épices traditionnelles. Servie avec du riz blanc, cette sauce généreuse séduit par sa texture veloutée et son goût authentique.",
    en: "A must-have West African speciality: okra slow-simmered into a smooth, fragrant sauce, often enriched with meat or fish and lifted with traditional spices. Served with white rice, this generous sauce charms with its velvety texture and authentic taste.",
    tag: "Spécialité",
  },
  {
    id: "lafidi-fonio",
    name: "Lafidi au Fonio",
    img: REAL.lafidiFonio,
    price: "14€",
    fr: "Le fonio, céréale ancestrale et légère d'Afrique de l'Ouest, servi avec le lafidi — une sauce aux feuilles et aux épices, relevée au piment frais. Un plat fin, parfumé et profondément authentique.",
    en: "Fonio, West Africa's light ancestral grain, served with lafidi — a leaf-and-spice sauce lifted with fresh chili. A delicate, fragrant and deeply authentic dish.",
    tag: "Fonio",
  },
  {
    id: "lafidi-maaro",
    name: "Lafidi (Fouti Maaro)",
    img: REAL.lafidiMaaro,
    price: "12€",
    fr: "La version à base de riz parfumé, nappée du lafidi — une sauce onctueuse aux gombos, feuilles et épices, relevée au piment et à l'huile de palme. Généreux et réconfortant.",
    en: "The fragrant-rice version, topped with lafidi — a smooth okra, leaf and spice sauce lifted with chili and palm oil. Generous and comforting.",
    tag: "Riz",
  },
];

export const DRINKS_IMG = "/img/drinks.jpg";

export const DRINKS = [
  {
    id: "bissap",
    name: "Bissap",
    price: "4€",
    accent: "#8B0000",
    fr: "Infusion de fleurs d'hibiscus, purement naturelle, servie bien fraîche.",
    en: "A naturally brewed hibiscus-flower infusion, served ice-cold.",
  },
  {
    id: "gingembre",
    name: "Gingembre",
    price: "5€",
    accent: "#D4AF37",
    fr: "Jus de gingembre frais, vif et tonifiant — la recette maison, purement naturelle.",
    en: "Fresh, zesty and invigorating ginger juice — our all-natural house recipe.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aïssatou D.",
    role: "Cliente fidèle · Paris 18e",
    stars: 5,
    fr: "Le meilleur thiéboudienne de Paris, sans exception. Les saveurs du Fouta sont là, entières, généreuses — on se croirait à Dakar le temps d'un dîner.",
    en: "The best thiéboudienne in Paris, no exception. The flavours of Fouta are all there, whole and generous — for one dinner you're back in Dakar.",
  },
  {
    name: "Marc L.",
    role: "Habitué du quartier",
    stars: 5,
    fr: "Un vrai bijou du 18e. Ambiance feutrée, lumière douce et service chaleureux : une petite boutique où l'on se sent immédiatement chez soi.",
    en: "A real gem of the 18th. Hushed atmosphere, soft light and warm service: a little boutique where you instantly feel at home.",
  },
  {
    name: "Fatou N.",
    role: "Découverte coup de cœur",
    stars: 5,
    fr: "Le yassa et le maffé sont divins, préparés avec des épices d'une justesse rare. Cette adresse respire l'âme du Fouta à chaque bouchée.",
    en: "The yassa and maffé are divine, cooked with rare, precise spicing. This place breathes the soul of Fouta in every bite.",
  },
  {
    name: "Julien P.",
    role: "Gourmet · Montmartre",
    stars: 5,
    fr: "Une table confidentielle et élégante. La générosité des plats, la fraîcheur des produits, l'attiéké parfait… tout y est. Ma cantine du dimanche.",
    en: "An intimate, elegant table. Generous plates, fresh produce, perfect attiéké… it's all there. My Sunday canteen.",
  },
  {
    name: "Awa S.",
    role: "Cliente depuis l'ouverture",
    stars: 5,
    fr: "Halal, généreux et raffiné. L'accueil est aussi soigné que la cuisine, dans une boutique parisienne pleine de charme. Un sans-faute.",
    en: "Halal, generous and refined. The welcome is as polished as the food, in a charming little Paris boutique. Flawless.",
  },
];
